import { render, staticRenderFns } from "./CMS.vue?vue&type=template&id=82f1575e&"
import script from "./CMS.vue?vue&type=script&lang=js&"
export * from "./CMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports